import { setup } from "web/entrypoints/common/setup";

// While testing `uj_feed_speed` we need to have the `feeds` content inside the `main` entrypoint too.
// TODO: Remove this after the `uj_feed_speed` experiment
import "web/entrypoints/feeds/baustein-feeds";
import feedComponents from "web/entrypoints/feeds/react-feeds";
import "web/entrypoints/feeds/css-feeds";

import "./baustein-main";
import "./css-main";
import components from "./react-main";

setup({
    // TODO: Remove this after the `uj_feed_speed` experiment too
    ...feedComponents,
    ...components,
});
